

/**
 * 因为想要使用emFilter的自定义查询功能（通过指定的filterState查询指定的api，返回的结果也存放到指定的loadState中）
 * 需要固定的在store中增加一些约定好的state，mutations和actions。所以把他们封装到本patternFactory中
 * 通过扩展的MmfVuexStoreHelper的withPatternFactory，可以批量添加上述内容。用例可参见【EmAclDeptStore】
 * author: YuJiaBei
 * date: 2020/8/6
 */

import emUtils from "@/utils/emUtils";

export function customQueryForEmFilterPatternFactory({
                                                         store: {state, actions, mutations}
                                                         , param: {
        loadState = "emCustomQueryNodes",
        filterState = "emCustomQueryFilter",
        modelFilter = {}
    }
                                                     } = {}) {
    //添加state
    Object.assign(state, {[loadState]: [], [filterState]: Object.assign({}, modelFilter)})
    //转换首字母大写
    let voStateCapFirst = emUtils.toCapFirst(loadState)
    let filterState_cap_first = emUtils.toCapFirst(filterState)
    //添加mutations
    Object.assign(mutations, {
        //设置filterStateAttribute
        [`set${filterState_cap_first}Attribute`](state, parameters) {
            state[filterState][parameters.key] = parameters.newValue;
        },
        // 清空filterState
        [`setClear${filterState_cap_first}`](state) {
            state[filterState] = Object.assign({}, modelFilter)
        },
        //整体设置
        [`set${voStateCapFirst}`](state, data) {
            state[loadState] = data
        },
        //设置属性
        [`set${voStateCapFirst}Attribute`](state, parameters) {
            state[loadState][parameters.key] = parameters.newValue;
        },
        //初始化
        [`clear${voStateCapFirst}`](state) {
            state[loadState] = []
        },
        [`addNewRow${voStateCapFirst}`](state, row) {
            if (!state[`newRows${voStateCapFirst}`].some(r => r === row)) {
                state[`newRows${voStateCapFirst}`].push(JSON.parse(JSON.stringify(Object.assign(row, state.entityHolder))));
            }
        },
        [`setNewRow${voStateCapFirst}`](state, parameters) {
            let stateRow = state[`newRows${voStateCapFirst}`].filter(r => r === parameters['row'])[0]
            stateRow[parameters.key] = parameters.newValue
        },
        [`setNewRows${voStateCapFirst}`](state, parameters) {
            let stateRow = state[`newRows${loadState}`].filter(r => r === parameters['row'])[0]
            stateRow[parameters.key] = parameters.newValue
        },
        [`setCheckedItems${voStateCapFirst}`](state, data) {
            state[`checkedItems${voStateCapFirst}`] = data
        },
        [`setShowNoResultAlert${voStateCapFirst}`](state, data) {
            state[`showNoResultAlert${voStateCapFirst}`] = data
        },
        [`addEditingRow${voStateCapFirst}`](state, row) {
            if (!state[`editingRows${voStateCapFirst}`].some(r => r === row)) {
                // 使用 clone 的结果，这样取消后不影响原始数据
                state[`editingRows${voStateCapFirst}`].push({...row});
            }
        },
        [`clearEditingRows${voStateCapFirst}`](state) {
            state[`editingRows${voStateCapFirst}`] = []
        },
        [`removeEditingRow${voStateCapFirst}`](state, row) {
            state[`editingRows${voStateCapFirst}`] = state[`editingRows${voStateCapFirst}`].filter(r => r.id !== row.id);
        },
        [`removeNewRow${voStateCapFirst}`](state, row) {
            state[`newRows${voStateCapFirst}`] = state[`newRows${voStateCapFirst}`].filter(r => r !== row);
        },
        [`setRow${voStateCapFirst}`](state, parameters) {
            let {row, key, newValue} = parameters;
            let stateRow = state[`editingRows${voStateCapFirst}`].filter(r => r.id === row.id)[0]
            stateRow[key] = newValue
        },
    })
    //添加actions
    Object.assign(actions, {
        //载入loadState
        [`load${voStateCapFirst}`](context, data) {
            context.commit(`set${voStateCapFirst}`, data)
        }
    })

}